import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { getProductivityRiskTrend as queryFn } from 'api/endPoints/getProductivityRiskTrend';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetProductivityRiskTrend = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, (QueryKeys | QueryParams)[]>({
        queryKey: ['getProductivityRiskTrend', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.latestVersionId) && Boolean(params.contractId) && Boolean(params.compareVersionId),
    });
};

export interface QueryParams extends NarrativeRequest {
    compareVersionId: number | undefined;
    contractId: number | null | undefined;
    latestVersionId: number | undefined;
    filter: any;
}

export type QueryResponse = [
    {
        name: string;
        graphPoints: GraphPoint[];
    },
];

export interface GraphPoint {
    versionName: string;
    versionDate: number;
    score: number;
    status: string;
    versionHashCode: number;
}
